import React, { useEffect, useState } from 'react';
import { convertSecondsToTimeShorted } from 'src/utils/CommonFunctions';

/**
 * LiveElapsedTimer — counts UP from `startDate`, re-rendering every second, formatted via
 * convertSecondsToTimeShorted ("1s", "2m 3s", …). When `isRunning` is false it stops ticking and
 * shows the elapsed value frozen at that point.
 */
interface IProps {
    startDate?: string | null;
    isRunning: boolean;
}

const elapsedSeconds = (startDate?: string | null) => {
    if (!startDate) return 0;
    const start = new Date(startDate).getTime();
    if (!Number.isFinite(start)) return 0;
    const diff = Math.floor((Date.now() - start) / 1000);

    return diff > 0 ? diff : 0;
};

const LiveElapsedTimer = ({ startDate, isRunning }: IProps) => {
    const [seconds, setSeconds] = useState(() => elapsedSeconds(startDate));

    useEffect(() => {
        setSeconds(elapsedSeconds(startDate));
        if (!isRunning || !startDate) return undefined;
        const id = setInterval(() => setSeconds(elapsedSeconds(startDate)), 1000);

        return () => clearInterval(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, isRunning]);

    return <>{convertSecondsToTimeShorted(seconds)}</>;
};

export default LiveElapsedTimer;
